<template>
    <TransitionRoot as="template" :show="show">
        <Dialog as="div" class="relative z-50" @close="$emit('close')">
            <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </TransitionChild>

            <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div class="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">
                    <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                        <DialogPanel class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
                            <div>
                                <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
                                    <font-awesome-icon :icon="faDoorOpen" class="h-6 w-6 text-green-600" aria-hidden="true" />
                                </div>
                                <div class="mt-3 text-center sm:mt-5">
                                    <DialogTitle as="h3" class="text-xl font-semibold leading-6 text-gray-900">Reopen this property for applications?</DialogTitle>
                                    <div class="mt-3">
                                        This reopens the listing to new applicants. Previously approved applicants will no longer hold this property.
                                    </div>
                                    <div class="mt-3">
                                        Your application link will show the property as available and the status will change to Active Application Link.
                                    </div>
                                </div>
                            </div>
                            <div class="mt-5 sm:mt-6 flex">
                                <button type="button" class="flex-shrink-0 w-1/2 mr-1 justify-center rounded-md bg-gray-50 border border-gray-200 px-3 py-2 text-sm font-semibold text-gray-700 shadow-sm hover:bg-gray-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600" @click="$emit('close')">Cancel</button>
                                <button type="button" class="primaryButton w-1/2 ml-1 justify-center rounded-md px-3 py-2 text-sm font-semibold text-white hover:bg-black focus:outline-2 focus:outline-offset-2 focus:outline-transparent disabled:opacity-60" :disabled="processing" @click="$emit('confirm')">Reopen</button>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script setup>
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faDoorOpen } from '@fortawesome/pro-solid-svg-icons'

defineProps({
    show: {
        type: Boolean,
        default: false
    },
    processing: {
        type: Boolean,
        default: false
    }
})

defineEmits(['close', 'confirm'])
</script>
